import React, { useState, useEffect } from 'react';
import Navbar from '../components/Navbar';
import { motion } from 'framer-motion';

const books = [
  { title: "The Direct Path To Linux Ubuntu", description: "Linux Ubuntu Full Course", url: "https://www.mywebuniversity.com/toc1w.html" },
  { title: "Linux Basic Level", description: "Linux Basic", url: "https://www.mywebuniversity.com/chapter-2w.html" },
  { title: "Linux Intermediate Level", description: "Linux Intermediate Level", url: "https://www.mywebuniversity.com/chapter-3w.html" },
  { title: "Linux Advanced Level", description: "Linux Advanced Level", url: "https://www.mywebuniversity.com/chapter-4w.html" },
  { title: "The Direct Path To Linux Shell Scripting", description: "Linux Shell Scripting Full Course", url: "https://www.mywebuniversity.com/chapter-5w.html" },
  { title: "Linux Essential", description: "Linux Basics, Intermediate and Advanced Levels", url: "https://www.mywebuniversity.com/toc1w.html" },
];

function Books() {
  return (
    <div className="min-h-screen bg-white dark:bg-gray-900 text-gray-800 dark:text-white transition">
      <Navbar />
      <div className="pt-24 px-6 max-w-4xl mx-auto">
        <br />
        <h2 className="text-2xl font-bold mb-6">Books</h2>
        <div className="grid gap-6">
          {books.map((book, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: index * 0.2 }}
              className="p-4 border rounded-lg shadow-md dark:border-gray-700"
            >
              <h3 className="text-xl font-semibold">{book.title}</h3>
              <p className="text-sm mt-2">{book.description}</p>

          <div className="mt-10">
          <iframe
            className="w-full aspect-video rounded-lg shadow-md"
            src={book.url}
            title={book.description}
            frameBorder="0"
            allowFullScreen
          ></iframe>
          </div>

            </motion.div>

          ))}
        </div>
      </div>
    </div>
  );
}
export default Books;
